import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesNoAnimated from '@amcharts/amcharts4/themes/amcharts';
import guid from '../../generic/Guid';
import { debounce } from 'underscore';
import styles from './Chart.module.scss';
import { Loading } from '../Loading/Loading';
import isEqual from 'lodash/isEqual';

am4core.useTheme(am4themesNoAnimated);
am4core.options.queue = true;

interface IMultipleLineSeriesProps {
    data: Array<Array<{ Time: Date, Value: number }>>;
    names: string[];
    colors: string[];
}
export default class MultipleLineSeries extends Component<IMultipleLineSeriesProps, { loading: boolean }> {
    amChart!: am4charts.XYChart;
    GUID = guid();

    constructor(props: IMultipleLineSeriesProps) {
        super(props);
        this.state = { loading: false };
    }

    componentDidMount() {
        this.createChart();
        this.createSeries();
        this.updateChartData();
    }

    componentWillUnmount() {
        if (this.amChart) {
            this.amChart.dispose();
        }
    }

    componentDidUpdate(oldProps: IMultipleLineSeriesProps) {
        if (!isEqual(oldProps.data, this.props.data) || !isEqual(oldProps.names, this.props.names)) {
            this.updateChartData();
        }
    }

    createChart = () => {
        const chart = am4core.create(this.GUID, am4charts.XYChart);
        chart.responsive.enabled = true;
        chart.cursor = new am4charts.XYCursor();
        chart.zoomOutButton.scale = 0.5;

        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.labels.template.fontSize = '10px';
        dateAxis.renderer.minGridDistance = 54;
        dateAxis.title.text = 'Time';
        dateAxis.groupData = false;

        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minLabelPosition = 0.01;
        valueAxis.renderer.labels.template.fontSize = '10px';
        valueAxis.renderer.minGridDistance = 50;

        this.amChart = chart;
    };

    createSeries = () => {
        this.props.data.forEach((_, index) => {
            const series = this.amChart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = 'Time';
            series.dataFields.valueY = 'Value';
            series.strokeWidth = 2;
            series.fillOpacity = 0;
            series.name = this.props.names[index];
            series.stroke = am4core.color(this.props.colors[index]);

            series.tooltipText = `{name}:[bold] {valueY}`;
            series.tooltip!.background.fill = am4core.color(this.props.colors[index]);
            series.tooltip!.background.stroke = am4core.color(this.props.colors[index]);
            series.tooltip!.getFillFromObject = false;
            series.tooltip!.background.fillOpacity = 0.5;

        });
    };

    updateChartData = debounce(() => {
        this.amChart.series.values.forEach((series, index) => {
            series.data = this.props.data[index];
        });
    }, 50);

    render() {
        return (
            <div className={styles.root} id={this.GUID}>
                <Loading loading={this.state.loading}></Loading>
            </div>
        );
    }
}
